import Base from './base'
import { Person, PersonCustomFields } from '../types/person'

type CreatePersonPayload = Partial<Person> & {
  account_id?: number
  custom_fields?: PersonCustomFields
}

type UpdatePersonPayload = Partial<Person> & {
  custom_fields?: PersonCustomFields
}

type FindPersonParams = {
  first_name?: string
  last_name?: string
  phone?: string
  mobile_phone?: string
  home_phone?: string
}

export default class MelodyPeople extends Base {
  async findByEmail(email: string) {
    try {
      return this.api.get(`people/find.json?email=${encodeURIComponent(email)}`)
    } catch (e) {
      return null
    }
  }

  async find(params: FindPersonParams = {}) {
    return this.api.get('people/find.json', { params })
  }

  create(payload: CreatePersonPayload) {
    return this.api.post('people', payload)
  }

  get(userId: number) {
    return this.api.get(`people/${userId}.json`)
  }

  update(userId: number, payload: UpdatePersonPayload) {
    return this.api.put(`people/${userId}.json`, payload)
  }

  getActiveCadences(ids: number[]) {
    return this.api.post('people/active_cadences.json', {
      people: ids,
    })
  }

  deletePerson(personId: number) {
    return this.api.delete(`people/${personId}`)
  }
}
